var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-row", style: { height: "auto" } }, [
    _c("div", { staticClass: "pricing" }, [
      _c("div", { staticClass: "table-page" }, [
        !_vm.showMobileVersion
          ? _c("div", { staticClass: "table-head" }, [
              _c("div", { staticClass: "table-row" }, [
                _c("div", { staticClass: "th" }),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [_vm._v("GROUP NAME")]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [
                  _vm.schoolCountry === "England"
                    ? _c("span", [_vm._v("YEARS")])
                    : _c("span", [_vm._v("GRADES")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [_vm._v("TIME")]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [_vm._v("COST")]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [_vm._v("ENROLLED/MAX")]),
                _vm._v(" "),
                _c("div", { staticClass: "th" }, [_vm._v("STATUS")])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-body" },
          _vm._l(_vm.pricings, function(pricing) {
            return _c("camp-pricing-row", {
              key: _vm.campId * pricing.id,
              attrs: {
                readonly: _vm.readonly,
                id: pricing.id,
                name: pricing.name,
                "time-from": pricing.timeFrom,
                "time-to": pricing.timeTo,
                price: pricing.price,
                "age-from": pricing.ageFrom,
                "age-to": pricing.ageTo,
                "grade-from": pricing.gradeFrom,
                "grade-to": pricing.gradeTo,
                enrolled: pricing.enrolled,
                "max-enroll": pricing.maxEnroll,
                "activity-status": pricing.activityStatus
              }
            })
          }),
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fdd11aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdd11aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camps/CampPricingsList.vue
// module id = null
// module chunks = 